import React from 'react';
import {t, Trans} from '@lingui/macro';
import {Input, Tag} from "antd";
import BatchInvoicingActions from 'bukku/redux/BatchInvoicing/actions';

export const CustomerCreditLimitInfo = {
    title: () => t`Credit Limit Exceeded`,
    onOk: (passcode, handleOk, action) => {
        if (passcode) {
            const newAction = {...action};

            // all batch transactions
            if (action.type === BatchInvoicingActions.BATCH_INVOICING_CREATE_REQUEST) {
                newAction.credit_limit_passcode = passcode;
                handleOk(newAction);
            }
            // single transaction / TRANSACTION_BULK_READY_REQUEST
            else {
                newAction.request.credit_limit_passcode = passcode;
                handleOk(newAction);
            }
        }
    },
    bodyStyle: {},
    noPasscode: false,
};

function CustomerCreditLimit(props) {
    // Redux
    const { message, passcode, setPasscode, passcodeRef } = props;

    return (
        <>
            <div style={{marginBottom: 16}}>
                <Trans>
                    Please provide the&nbsp;
                    <Tag>Customer Credit Limit</Tag>
                    passcode to proceed.
                </Trans>
            </div>
            <Input.Password
                ref={passcodeRef}
                addonBefore={t`Passcode`}
                type="number"
                value={passcode}
                onChange={e => setPasscode(e.target.value)}
                // onPressEnter={() => CustomerCreditLimitInfo.onOk(passcode, handleOk, action)}
                placeholder="####"
            />
            { message ? <div style={{marginTop: 16, color: "#ff4d4f"}}>{message}</div> : null}
        </>
    );
}

export default CustomerCreditLimit;
